import { t } from 'i18next'
import { Checkbox } from '@microservices/wiskey-react-components'
import { ColumnDef } from '@tanstack/react-table'

import { BIND_TYPE, FIELD_VALUE_TYPE, NAMES_FIELDS } from '@constants'
import { FormattedColumnRestrictions, RESTRICTION_TYPE } from '@types'

type QuickSearchColumnProps = {
  updateRestrictions: (restrictions: any[]) => Promise<void>
  viewId: number
}

const getIsQSAvailable = (
  bindType: BIND_TYPE,
  value: string,
  valueType: FIELD_VALUE_TYPE,
  objectValue: string | null
) => {
  return (
    bindType === BIND_TYPE.FIELD &&
    value !== NAMES_FIELDS._ID &&
    objectValue !== NAMES_FIELDS._ID &&
    valueType !== FIELD_VALUE_TYPE.DATETIME
  )
}

export const generateQuickSearchColumns = ({
  updateRestrictions,
  viewId,
}: QuickSearchColumnProps): ColumnDef<FormattedColumnRestrictions>[] => {
  const handleQuickSearchChange = (
    value: boolean | null,
    fieldCode: string,
    fieldName: string,
    restrictionType: RESTRICTION_TYPE
  ) => {
    updateRestrictions([
      {
        viewId,
        fieldCode,
        fieldName,
        restrictionType,
        value,
      },
    ])
  }

  return [
    {
      accessorKey: 'qs_enabled',
      header: t('viewColumnsTable.qsEnabled'),
      enableSorting: false,
      cell: ({ cell }) => {
        const {
          fieldCode,
          fieldName,
          bindType,
          value,
          valueType,
          objectValue,
          quickSearchPermission,
        } = cell.row.original

        const isQSAvailable = getIsQSAvailable(bindType, value, valueType, objectValue)

        const isChecked =
          isQSAvailable &&
          (quickSearchPermission?.value === true ||
            quickSearchPermission?.value === 'true' ||
            quickSearchPermission?.value === undefined)

        return (
          <Checkbox
            checked={isChecked}
            disabled={!isQSAvailable}
            sx={{ height: 30 }}
            onChange={(_e, checked) =>
              handleQuickSearchChange(
                checked,
                fieldCode,
                fieldName,
                RESTRICTION_TYPE.QUICK_SEARCH_PERMISSION
              )
            }
          />
        )
      },
      minSize: 100,
      size: 100,
    },
    {
      accessorKey: 'qs_default',
      header: t('viewColumnsTable.qsDefault'),
      enableSorting: false,
      cell: ({ cell }) => {
        const {
          fieldCode,
          fieldName,
          bindType,
          value,
          valueType,
          objectValue,
          quickSearchChoice,
          quickSearchPermission,
        } = cell.row.original

        const isQSAvailable = getIsQSAvailable(bindType, value, valueType, objectValue)

        const isChecked =
          isQSAvailable &&
          (quickSearchChoice?.value === true || quickSearchChoice?.value === 'true')

        const isDisabled =
          !isQSAvailable ||
          quickSearchPermission?.value === false ||
          quickSearchPermission?.value === 'false'

        return (
          <Checkbox
            checked={isChecked}
            disabled={isDisabled}
            sx={{ height: 30 }}
            onChange={(_e, checked) =>
              handleQuickSearchChange(
                checked ? true : null,
                fieldCode,
                fieldName,
                RESTRICTION_TYPE.QUICK_SEARCH_CHOICE
              )
            }
          />
        )
      },
      minSize: 100,
      size: 100,
    },
  ]
}
